export const templateComps = {
  confirmModal: {
    cancel: "Cancelar",
    delete: "Eliminar",
  },
  channexIncident: {
    kicker: "Aviso importante",
    brandTitle: "Incidencia externa",
    closeLabel: "Cerrar aviso",
    subtitle:
      "Estamos monitorizando la situación y revisaremos la sincronización cuando el servicio se restablezca.",
    title:
      "Incidencia general en la conexión con Booking / Airbnb / channel manager externo",
    lead: "Hola, estamos detectando una incidencia general en nuestro proveedor externo de sincronización con OTAs.",
    text: "Esta incidencia afecta a su API y puede retrasar la sincronización de reservas, disponibilidad y cierres de fechas.",
    note: "En cuanto la conexión vuelva a estar operativa, realizaremos una revisión de la sincronización de datos para verificar reservas, disponibilidad y cierres de fechas.",
    textLast:
      "Desde WA Checkin revisaremos la sincronización cuando el servicio vuelva a estar operativo.",
    button: "Entendido",
  },
  notificationsNav: {
    title: "Notificaciones",
    recent: "recientes",
    emptyTitle: "No hay notificaciones",
    emptyText:
      "Cuando ocurra algo importante en tus reservas, aparecerá aquí.",
    seeAll: "Ver todas las notificaciones",
    meta: {
      t1: { status: "Nueva", category: "reserva" },
      t2: { status: "Actualizada", category: "reserva" },
      t3: { status: "Cancelada", category: "reserva" },
      t4: { status: "Realizado", category: "check-in" },
      t5: { status: "Solicitado", category: "servicio" },
      t6: { status: "Recibida", category: "solicitud" },
      t7: { status: "Aprobada", category: "solicitud" },
      t8: { status: "Rechazada", category: "solicitud" },
      t9: { status: "Confirmado", category: "pago" },
      t10: { status: "En proceso de pago", category: "pago pendiente" },
      t11: { status: "Asignar habitación", category: "reserva" },
      t12: { status: "Envío fallido", category: "check-in" },
      t13: { status: "No enviado", category: "registro viajeros" },
      t15: { status: "Activa", category: "suscripción" },
      default: { status: "Aviso", category: "sistema" },
    },
    typeLabel: {
      t1: "NUEVA RESERVA",
      t2: "RESERVA ACTUALIZADA",
      t3: "RESERVA CANCELADA",
      t4: "CHECK-IN",
      t5: "SERVICIO",
      t6: "SOLICITUD",
      t7: "SOLICITUD APROBADA",
      t8: "SOLICITUD RECHAZADA",
      t10: "EN PROCESO DE PAGO",
      t11: "ASIGNAR HABITACIÓN",
      t12: "ENVÍO FALLIDO",
      t13: "REGISTRO VIAJEROS",
      t15: "SUSCRIPCIÓN ACTIVA",
      default: "NOTIFICACIÓN",
    },
  },
};
